// WARNING: Do NOT edit this file outside npm-helsecore, it will be reset on build!

import type { PressPhotosProps } from '@dip/helsecore/src/components/parts/PressPhotos/PressPhotos.d';

import React from 'react';
import { PressPhotos } from '@dip/helsecore/src/components/parts/PressPhotos/PressPhotos';

export default (props: Readonly<PressPhotosProps>) => <PressPhotos {...props} />
